import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useMangoApi } from '~/atoms/MangoApi'

import { ApiError, PaginatedApiResult, Pbx } from '@mangovoice/types'

export const useGetPbxList = ({
  onQuerySuccess,
  options = {},
  apiParams = {},
}: {
  onQuerySuccess?: (data: PaginatedApiResult<Pbx>) => void
  options?: Omit<UseQueryOptions<PaginatedApiResult<Pbx>, ApiError>, 'queryKey'>
  apiParams?: { limit?: number }
}) => {
  const api = useMangoApi()
  return useQuery<PaginatedApiResult<Pbx>, ApiError>({
    queryKey: ['userPbxList', { apiParams }],
    queryFn: async () => {
      const { ok, data } = await api.getUserPbxList(apiParams)

      if (!ok) {
        return Promise.reject(data)
      }
      onQuerySuccess?.(data!)
      return data!
    },
    ...options,
    retry: options.retry ?? false,
  })
}

interface UseGetPbxDetailParams {
  pbxId: string
  options?: Omit<UseQueryOptions<Pbx, ApiError>, 'queryKey'>
}
export const useGetPbx = ({ pbxId, options = {} }: UseGetPbxDetailParams) => {
  const api = useMangoApi()
  return useQuery<Pbx, ApiError>({
    queryKey: ['pbx', pbxId],
    queryFn: async () => {
      const { ok, data } = await api.getPbx(pbxId)
      if (!ok) {
        return Promise.reject(data)
      }
      return data!
    },
    ...options,
    retry: options.retry ?? false,
  })
}
